// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import DropdownController from "./dropdown_controller"
import DeliveryCheckController from "./delivery_check_controller"
import ToggleController from "./toggle_controller"

application.register("hello", HelloController)
application.register("dropdown", DropdownController)
application.register("delivery-check", DeliveryCheckController)
application.register("toggle", ToggleController)
import OfflineOrderFormController from "./offline_order_form_controller"
application.register("offline-order-form", OfflineOrderFormController)

import OrderAlertsController from "./order_alerts_controller"
application.register("order-alerts", OrderAlertsController)

import AddressMapController from "./address_map_controller"
application.register("address-map", AddressMapController)

import MembershipPlanController from "./membership_plan_controller"
application.register("membership-plan", MembershipPlanController)

import CartControlController from "./cart_control_controller"
application.register("cart-control", CartControlController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)
